import React from "react";

import StarRatingComponent from "react-star-rating-component";

const ShowRate = ({ rank }) => {
  // console.log(Math.round(rank));
  return (
    <div className="font-size--4">
      <StarRatingComponent
        name="show-rate"
        editing={false}
        // renderStarIcon={() => <span></span>}
        starCount={5}
        value={Math.round(rank)}
      />
    </div>
  );
};

export default ShowRate;
